import type { RoutePathsModule } from '../router/getTranslatedPathnames';

const modules = import.meta.glob<RoutePathsModule>('./*/route.paths.ts', { eager: true });

export const pathsEntries: ReadonlyArray<readonly [name: string, mod: RoutePathsModule]> = Object.entries(modules)
  .map(([path, mod]) => [path.split('/')[1] ?? path, mod] as const)
  .sort(([a], [b]) => a.localeCompare(b));
